import React from "react";
import { StyledProgressBar } from "./styles";

function ProgressBar() {
  return <StyledProgressBar />;
}

export default ProgressBar;
